import { auth } from "./firebase";

// fetch() for /api/admin/* routes: attaches the signed-in user's Firebase ID
// token, which the routes check with requireClabsAdmin.
export async function adminFetch(input: string, init: RequestInit = {}): Promise<Response> {
  await auth.authStateReady();
  const user = auth.currentUser;
  if (!user) throw new Error("Sign in again to continue.");
  const headers = new Headers(init.headers);
  headers.set("Authorization", `Bearer ${await user.getIdToken()}`);
  return fetch(input, { ...init, headers });
}
